import * as tslib_1 from "tslib";
import { OnInit } from '@angular/core';
import { Validators } from '@angular/forms';
import { MatDialogRef, MatDialog } from '@angular/material';
import { MediaFolder, RenameFolderDialogData, FolderNode, ConfirmDialogData, MediaTranslation } from 'src/app/utils/common-classes';
import { ConfirmDialogComponent } from '../confirm-dialog/confirm-dialog.component';
export class RenameFolderDialogComponent {
    constructor(dialogRef, data, fb, folderService, utils, dialog) {
        this.dialogRef = dialogRef;
        this.data = data;
        this.fb = fb;
        this.folderService = folderService;
        this.utils = utils;
        this.dialog = dialog;
    }
    ngOnInit() {
        this.form = this.fb.group({
            folderName: ['', [Validators.required, Validators.pattern('^[^\\/?%*:|"<>\.]+$')]],
            description: ['']
        });
        this.folder = this.data.node;
        this.form.get('folderName').setValue(this.folder.name);
        this.form.get('description').setValue(this.folder.description);
        this.selectedLanguageName = this.form.get('folderName').value;
        this.selectedLanguageDescription = this.form.get('description').value;
        this.utils.setDialogUnclosable(true);
    }
    closeDialog() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            let _self = this;
            if (!_self.edited() && !_self.creatingNew) {
                _self.utils.setDialogUnclosable(false);
                _self.dialogRef.close(_self.folder);
            }
            else {
                let title = yield _self.utils.translateKey("dialog.confirm.title.unsaved-changes");
                let message = yield _self.utils.translateKey("dialog.confirm.message.unsaved-changes");
                let data = { title: title, message: message };
                let confirmLeaveDialog = _self.dialog.open(ConfirmDialogComponent, { width: "400px", data: data, disableClose: true });
                confirmLeaveDialog.afterClosed().subscribe((confirm) => {
                    if (confirm) {
                        _self.utils.setDialogUnclosable(false);
                        _self.dialogRef.close(_self.folder);
                    }
                });
            }
        });
    }
    submit() {
        let _self = this;
        _self.formSubmitAttempt = true;
        if (_self.form.valid) {
            let folderName = _self.form.get('folderName').value;
            let description = _self.form.get('description').value;
            _self.utils.showShortLoader();
            let mediaTranslation = new MediaTranslation();
            mediaTranslation.languageId = _self.selectedLanguage;
            mediaTranslation.name = folderName;
            mediaTranslation.description = description;
            mediaTranslation.mediaFolderId = _self.folder.mediaFolderId;
            _self.folderService.setFolderTranslation(mediaTranslation).then((folder) => {
                _self.folder = FolderNode.fromMediaFolder(folder, _self.folder.level);
                _self.updateData(_self.selectedLanguage);
                _self.creatingNew = false;
            }).catch((err) => {
                return _self.utils.getError(err);
            }).finally(() => {
                _self.utils.hideShortLoader();
            });
        }
    }
    deleteTranslation() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            let _self = this;
            if (!_self.creatingNew && _self.folder.translations && _self.folder.translations.get(_self.selectedLanguage)) {
                let title = yield _self.utils.translateKey("dialog.confirm.title.delete-translation");
                let message = yield _self.utils.translateKey("dialog.confirm.message.delete-translation");
                let data = { title: title, message: message };
                let confirmLeaveDialog = _self.dialog.open(ConfirmDialogComponent, { width: "400px", data: data, disableClose: true });
                confirmLeaveDialog.afterClosed().subscribe((confirm) => {
                    if (confirm) {
                        let mediaTranslation = new MediaTranslation();
                        mediaTranslation.mediaTranslationId = _self.folder.translations.get(_self.selectedLanguage).mediaTranslationId;
                        _self.folderService.deleteTranslation(mediaTranslation).then((folder) => {
                            _self.folder = FolderNode.fromMediaFolder(folder, _self.folder.level);
                            _self.updateData(_self.selectedLanguage);
                            _self.creatingNew = false;
                        }).catch((err) => {
                            return _self.utils.getError(err);
                        }).finally(() => {
                            _self.utils.hideShortLoader();
                        });
                    }
                });
            }
            else {
                _self.updateData(_self.selectedLanguage);
                _self.creatingNew = false;
            }
        });
    }
    cancel() {
        let _self = this;
        _self.updateData(_self.selectedLanguage);
    }
    selectLanguage(language) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            let _self = this;
            if (language != _self.selectedLanguage) {
                if (!_self.edited() && !_self.creatingNew) {
                    _self.updateData(language);
                }
                else {
                    let title = yield _self.utils.translateKey("dialog.confirm.title.unsaved-changes");
                    let message = yield _self.utils.translateKey("dialog.confirm.message.unsaved-changes");
                    let data = { title: title, message: message };
                    let confirmLeaveDialog = _self.dialog.open(ConfirmDialogComponent, { width: "400px", data: data, disableClose: true });
                    confirmLeaveDialog.afterClosed().subscribe((cancel) => {
                        if (cancel) {
                            _self.updateData(language);
                            _self.creatingNew = false;
                        }
                    });
                }
            }
        });
    }
    updateData(language) {
        let _self = this;
        let folder = _self.folder;
        _self.selectedLanguageName = "";
        _self.selectedLanguageDescription = "";
        if (language) {
            if (folder.translations.get(language)) {
                _self.selectedLanguageName = _self.folder.translations.get(language).name || "";
                _self.selectedLanguageDescription = _self.folder.translations.get(language).description || "";
            }
        }
        else {
            _self.selectedLanguageName = _self.folder.name;
            _self.selectedLanguageDescription = _self.folder.description || "";
        }
        _self.form.get('folderName').setValue(_self.selectedLanguageName);
        _self.form.get('description').setValue(_self.selectedLanguageDescription);
        _self.selectedLanguage = language;
    }
    edited() {
        let _self = this;
        return _self.selectedLanguageName != _self.form.get('folderName').value || _self.selectedLanguageDescription != _self.form.get('description').value;
    }
    createNewTranslation() {
        let _self = this;
        _self.creatingNew = true;
    }
}
